import { Button, Card, Col, Row } from 'react-bootstrap';
import {
  RECORD_FIELDS,
  RECORD_FIELDS_TO_RENDER,
  fetchAndSetSearchResults,
  handleEnterKeyDown,
  handleGlobalSearchChange,
  highlightSearchTerms,
  sortSearchResultsByCategory,
} from './globalSearch.helpers';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import $globalSearchResults from './globalSearchResults.signal';
import BreadCrumbWrapper from '../BreadCrumbs/BreadCrumbs';
import {
  handleGlobalSearch
} from 'libs/searchNavigation';
import Field from '../Field';
import Loader from '../Loader';
import HTMLRenderer from '../HTMLRenderer';
import { ensureHttpsInHrefs } from 'libs/string';
import { camelCaseToTitleText } from 'utils/formatTxt';
import { redirectToResourceFromGlobalSearch } from 'libs/searchNavigation';


const CardContent = ({ searchResult, searchQuery }) => {
  const fieldsToRender = RECORD_FIELDS_TO_RENDER[searchResult.recordType] || [];
  return (
  <Card.Body className="px-40 py-24">
    <Row>
      {(RECORD_FIELDS_TO_RENDER[searchResult.recordType] ?? []).map((field) => {
        const value = RECORD_FIELDS[field](searchResult.record, searchResult);
        if (value === null) return null;
        const valueStr = String(value);
        const displayValue = valueStr.length > 80 ? `${valueStr.substring(0, 80)}...` : valueStr;
        return (
        <Col
          key={field}
          className={`col-12 ${
            field === 'Description' ? '' : 'col-sm-6 col-lg-3'
          }`}
        >
          <p className="mb-0 font-weight-bold">{field}:</p>
          {field === 'Description' && searchResult.recordType === 'FundingProgram' ?
            (
              <HTMLRenderer className="mb-0" htmlString={ensureHttpsInHrefs(value)} />
            ) :
            (
              <p>{searchQuery ? highlightSearchTerms(displayValue, searchQuery) : displayValue}</p>
            )}
        </Col>
        );
      })}
    </Row>
  </Card.Body>
  );
};

const GlobalSearchResults = () => {
  const location = useLocation();
  const urlQuery = new URLSearchParams(location.search).get('query') ?? '';
  const preloaded = location.state?.searchResults;
  const preloadedQuery = location.state?.query;

  useEffect(() => {
    if (preloaded?.length && preloadedQuery === urlQuery) {
      $globalSearchResults.update({ searchResults: preloaded, query: urlQuery, isLoading: false });
      return;
    }
    fetchAndSetSearchResults();
  }, [urlQuery, preloaded, preloadedQuery]);
  return (
    <BreadCrumbWrapper className="mb-40">
      <Card className="p-32">
        <Row className="align-items-center">
          <Col>
            <h3>
              Search Results
              {$globalSearchResults.value?.searchResults?.length != null && (
                <span className="text-muted font-weight-normal ml-8 search-results-count">
                  ({$globalSearchResults.value.searchResults.length} {$globalSearchResults.value.searchResults.length === 1 ? 'result' : 'results'})
                </span>
              )}
            </h3>
          </Col>
          <Col>
            <div className="d-flex align-items-end w-100">
              <Field.TextInput
                labelClassName="font-weight-bold"
                className="w-100"
                value={$globalSearchResults.value?.query || ''}
                onChange={handleGlobalSearchChange}
                onKeyDown={handleEnterKeyDown}
              />
              <Button
                className="ml-16"
                onClick={() =>
                  handleGlobalSearch($globalSearchResults.value?.query || ''  )
                }
              >
                Search
              </Button>
            </div>
          </Col>
        </Row>
        <hr />
        {$globalSearchResults.value?.isLoading && (
          <div className="py-40 d-flex justify-content-center">
            <Loader message="Searching..." />
          </div>
        )}
        {!$globalSearchResults.value?.isLoading && !$globalSearchResults.value?.searchResults?.length && (
          <p className="font-weight-bold">
            We&apos;re sorry. We were not able to find a match. Please try
            another search.
          </p>
        )}

        {!$globalSearchResults.value?.isLoading && sortSearchResultsByCategory($globalSearchResults.value.searchResults)?.map((searchResult, index) => (
          <Card key={searchResult?.id ?? `search-result-${index}`} className="mt-24">
            <Card.Header className="rounded-0 font-weight-bold d-flex justify-content-between align-items-center">
              <h5 className="mb-0">{searchResult.recordType === 'VentureCapitalFirm'
            ? 'VC'
            : camelCaseToTitleText(searchResult.recordType)} - {searchResult.recordId}</h5>
              <p
                className="pointer text-primary mb-0"
                onClick={() => redirectToResourceFromGlobalSearch(searchResult)}
              >
                <u>View</u>
              </p>
            </Card.Header>
            <CardContent searchResult={searchResult} searchQuery={$globalSearchResults.value?.query} />
          </Card>
        ))}
      </Card>
    </BreadCrumbWrapper>
  );
};

const GlobalSearchResultsWithKey = () => {
  const location = useLocation();
  const searchKey = (location && location.search) ? location.search : '';
  return <GlobalSearchResults key={searchKey} />;
};

export default GlobalSearchResultsWithKey;
